import {commentAllDataLoader} from '../../../util/dataLoader';
import {IAllCommentsAPIResponse} from './allCommentsSlice';


export function getAllComments(filters) {
  return new Promise<IAllCommentsAPIResponse>((resolve) => {
    commentAllDataLoader.get(filters).then((res: IAllCommentsAPIResponse) => {
      resolve(res)
    })
  })
}
